'use strict';

var _ = require('lodash');
var UserActionService = function UserActionService($log, $rootScope, $interval, momentService, logService, userService, userSecureService, userPreferencesService) {
  var TOOLTIP_ITEMS_COUNT = 3;
  var CACHE_TTL = 10 /*minutes*/ * 60 /*seconds*/ * 1000 /*milliseconds*/;
  var cache = {};
  $interval(function () {
    var now = momentService.now(momentService.TYPE.DATE_TIME);
    for (var cacheKey in cache) {
      removeCacheEntryIfExpired(cacheKey, now);
    }
  }, CACHE_TTL);
  function saveUserAction(domain, ids, type) {
    var now = momentService.now(momentService.TYPE.DATE_TIME);
    var savedIds = ids.reduce(function (accumulator, id) {
      if (id === undefined) {
        throw Error('Detected undefined id when saving user action: "domain=' + domain + ', type=' + type + ', ids=' + ids + '"');
      }
      var key = domain + '_' + id + '_' + type;
      var expireTimeStamp = removeCacheEntryIfExpired(key, now);
      if (expireTimeStamp === undefined) {
        $log.debug('User action for key: ' + key + ' does not exist in cache. Sending user action.');
        var userAction = {
          domain: domain,
          key: id,
          type: type,
          timestamp: now.value.utc().toISOString()
        };
        logService.logUserAction(userAction);
        updateCacheEntry(key, now);
        accumulator[id] = true;
      } else {
        $log.debug('User action for key: ' + key + ' exists in cache (ttl=' + expireTimeStamp.toISOString() + '). User action is not sent.');
      }
      return accumulator;
    }, {});
    if (_.size(savedIds) > 0) {
      $rootScope.$broadcast('last-review:update-grid', type, savedIds);
    }
    return savedIds;
  }
  function updateCacheEntry(cacheKey, now) {
    cache[cacheKey] = now.add(CACHE_TTL, 'milliseconds');
  }
  function removeCacheEntryIfExpired(cacheKey, now) {
    var expireTimeStamp = cache[cacheKey];
    if (expireTimeStamp !== undefined && expireTimeStamp.isBefore(now)) {
      delete cache[cacheKey];
      $log.debug('User action (' + cacheKey + ') was removed from cache.');
      expireTimeStamp = undefined;
    }
    return expireTimeStamp;
  }
  function formatActionsList(actions) {
    return _.chain(actions).map(function (action) {
      return {
        type: action.type,
        time: getMomentOfDate(action.timestamp),
        user: userService.getUserDisplayName(action.userId)
      };
    }).value();
  }
  function getMomentOfDate(date) {
    return momentService.of(date, momentService.FIELD.CREATED_AT);
  }
  function isButtonVisible() {
    return userPreferencesService.getUserSettingComponent('useButtonToTriggerReviewAction');
  }
  function prepareReviewCellsToUpdate(actionType, flightIds, allRows) {
    var cellsToBeUpdated = [];
    var now = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var user = userService.getUserDisplayName(userSecureService.getUserId());
    if (!_.isUndefined(allRows)) {
      allRows.forEach(function (row, index) {
        if (flightIds[row.flightId]) {
          cellsToBeUpdated.push(updateCell(index, 'actionType', actionType));
          cellsToBeUpdated.push(updateCell(index, 'actionTime', now));
          cellsToBeUpdated.push(updateCell(index, 'actionUser', user));
          updateTooltip(row, actionType, user, now);
        }
      });
    } else {
      $log.debug('Loaded data (allRows) is undefined. No cells to be updated...');
    }
    return cellsToBeUpdated;
  }
  function updateCell(index, actionType, action) {
    return {
      rowId: index,
      columnName: actionType,
      newValue: action
    };
  }
  function updateTooltip(row, action, user, time) {
    var newAction = {
      type: action,
      user: user,
      time: time
    };
    if (row.actions) {
      if (row.actions.length === TOOLTIP_ITEMS_COUNT) {
        row.actions.pop();
      }
      row.actions.unshift(newAction);
    } else {
      row.actions = [newAction];
    }
  }
  return {
    saveUserAction: saveUserAction,
    prepareReviewCellsToUpdate: prepareReviewCellsToUpdate,
    formatActionsList: formatActionsList,
    isButtonVisible: isButtonVisible
  };
};
UserActionService.$inject = ['$log', '$rootScope', '$interval', 'MomentService', 'LogService', 'UserProcessingTransformationService', 'UserSecureService', 'UserPreferencesService'];
module.exports = UserActionService;